import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Icons
import { useRole } from "components/Hooks/UserHooks";
import FeatherIcon from "feather-icons-react";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";

const Navdata = () => {
    const history = useNavigate();
    const { t } = useTranslation();
    const { userPermissions } = useRole();

    const [menuActive, setMenuActive] = useState<string>('DASHBOARD');

    // Multi Level
    const [isLevel1, setIsLevel1] = useState<boolean>(false);

    const [isCurrentState, setIsCurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
    }, [history]);

    const menuItems: any = [
        // {
        //     id: "dashboard",
        //     label: t('Dashboards'),
        //     icon: <FeatherIcon icon="home" className="icon-dual" />,
        //     link: ROUTES.DASHBOARD,
        //     click: function (e: any) {
        //         setMenuActive((prev) => 'DASHBOARD');
        //         setIsCurrentState((prev) => 'Dashboard');
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: (menuActive === 'DASHBOARD'),
        //     isShow: isHavePermissionRole(ROLES_FOR_APP.DASHBOARD_VIEW, userPermissions),
        //     // subItems: []
        // },
        // {
        //     id: "multilevel12",
        //     label: t("Recommend Keyword"),
        //     icon: <i className="ri-flashlight-line" />,
        //     link: ROUTES.RECOMMEND_KEYWORD,
        //     click: function (e: any) {
        //         setMenuActive((prev) => "RECOMMEND_KEYWORD");
        //         setIsCurrentState((prev) => "Recommend Keyword");
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: menuActive === "RECOMMEND_KEYWORD",
        //     isShow: isHavePermissionRole([ROLES_FOR_APP.RECOMMEND_KEYWORD], userPermissions),
        // },
        {
            id: "multilevel12",
            label: t('Recommend Keyword'),
            icon: <i className="ri-flashlight-line" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => 'RECOMMEND_KEYWORD');
                setIsCurrentState((prev) => "Recommend Keyword");
                updateIconSidebar(e);
            },
            stateVariables: (menuActive === 'RECOMMEND_KEYWORD'),
            isShow: true,
            subItems: [
                {
                    id: "recommend-real-time-keyword",
                    label: t('Recommend Real-time Keyword'),
                    link: ROUTES.RECOMMEND_REAL_TIME_KEYWORD,
                    isShow: true,
                },
                {
                    id: "recommend-popular-keyword",
                    label: t('Recommend Popular Keyword'),
                    link: ROUTES.RECOMMEND_POPULAR_KEYWORD,
                    isShow: true,
                },
            ],
        },
        {
            id: "multilevel12",
            label: t("AI News"),
            icon: <i className="ri-newspaper-line" />,
            link: ROUTES.AI_NEWS,
            click: function (e: any) {
                setMenuActive((prev) => "AI_NEWS");
                setIsCurrentState((prev) => "AI News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "AI_NEWS",
            isShow: isHavePermissionRole([ROLES_FOR_APP.AI_NEWS], userPermissions),
        },
        {
            id: "multilevel5",
            label: t("Government News"),
            icon: <i className="ri-newspaper-line" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "GOVERNMENT_NEWS");
                setIsCurrentState((prev) => "Government News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "GOVERNMENT_NEWS",
            isShow: isHavePermissionRole(
                [
                    ROLES_FOR_APP.GOVERNMENT_IMAGE_BASED_NEWS,
                    ROLES_FOR_APP.GOVERNMENT_LOGO_BASED_NEWS
                ],
                userPermissions
            ),
            subItems: [
                {
                    id: "image-based-news",
                    label: t('Image Based News'),
                    link: ROUTES.GOVERNMENT_IMAGE_BASED_NEWS,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.GOVERNMENT_IMAGE_BASED_NEWS], userPermissions),
                },
                {
                    id: "logo-based-news",
                    label: t('Logo Based News'),
                    link: ROUTES.GOVERNMENT_LOGO_BASED_NEWS,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.GOVERNMENT_LOGO_BASED_NEWS], userPermissions),
                },
            ],
        },
        {
            id: "multilevel12",
            label: t("Boosting News"),
            icon: <i className="ri-newspaper-line" />,
            link: ROUTES.BOOSTING_NEWS,
            click: function (e: any) {
                setMenuActive((prev) => "BOOSTING_NEWS");
                setIsCurrentState((prev) => "Boosting News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "BOOSTING_NEWS",
            isShow: isHavePermissionRole([ROLES_FOR_APP.BOOSTING_NEWS], userPermissions),
        },
        {
            id: "multilevel12",
            label: t("Create AI Article"),
            icon: <i className="bx bxs-magic-wand" />,
            link: ROUTES.AI_ARTICLE_GENERATION,
            click: function (e: any) {
                setMenuActive((prev) => "AI_ARTICLE_GENERATION");
                setIsCurrentState((prev) => "Create AI Article");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "AI_ARTICLE_GENERATION",
            isShow: isHavePermissionRole([ROLES_FOR_APP.AI_ARTICLE_GENERATION], userPermissions),
        },
        // {
        //     id: "multilevel12",
        //     label: t("Image Repository"),
        //     icon: <i className="ri ri-landscape-line fs-20" />,
        //     link: ROUTES.IMAGE_REPOSITORY,
        //     click: function (e: any) {
        //         setMenuActive((prev) => "IMAGE_REPOSITORY");
        //         setIsCurrentState((prev) => "Image Repository");
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: menuActive === "IMAGE_REPOSITORY",
        //     isShow: isHavePermissionRole([ROLES_FOR_APP.IMAGE_REPOSITORY], userPermissions),
        // },
        {
            id: "multilevel999",
            label: t('Image Repository'),
            icon: <i className="ri ri-landscape-line fs-20" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => 'IMAGE_REPOSITORY');
                setIsCurrentState((prev) => "Image Repository");
                updateIconSidebar(e);
            },
            stateVariables: (menuActive === 'IMAGE_REPOSITORY'),
            isShow: isHavePermissionRole([
                ROLES_FOR_APP.MY_IMAGES,
                ROLES_FOR_APP.PUBLIC_IMAGES
            ], userPermissions),
            subItems: [
                {
                    id: "my-images",
                    label: t('My Images'),
                    link: ROUTES.MY_IMAGES,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.MY_IMAGES, userPermissions),
                },
                {
                    id: "public-images",
                    label: t('Public Images'),
                    link: ROUTES.PUBLIC_IMAGES,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.PUBLIC_IMAGES, userPermissions),
                },
            ],
        },

        // {
        //     id: "multilevel12",
        //     label: t("Real-Time News"),
        //     icon: <i className="ri-newspaper-line" />,
        //     link: ROUTES.REAL_TIME_NEWS,
        //     click: function (e: any) {
        //         setMenuActive((prev) => "REAL_TIME_NEWS");
        //         setIsCurrentState((prev) => "Real-Time News");
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: menuActive === "REAL_TIME_NEWS",
        //     isShow: isHavePermissionRole([ROLES_FOR_APP.REAL_TIME_NEWS], userPermissions),
        // },
        {
            id: "multilevel13",
            label: t("My News"),
            icon: <i className="ri-file-paper-2-line" />,
            link: ROUTES.MY_NEWS,
            click: function (e: any) {
                setMenuActive((prev) => "MY_NEWS");
                setIsCurrentState((prev) => "My News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "MY_NEWS",
            isShow: isHavePermissionRole([ROLES_FOR_APP.MY_NEWS], userPermissions),
        },
        // {
        //     id: "logout",
        //     label: "Logout",
        //     icon: <FeatherIcon icon="log-out" className="icon-log-out" />,
        //     link: "/logout",
        //     stateVariables: isDashboard,
        //     click: function (e: any) {
        //         e.preventDefault();
        //         setIsDashboard(!isDashboard);
        //         setIsCurrentState( (prev) =>  'Dashboard');
        //         updateIconSidebar(e);
        //     },
        // },
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
